{
    "previous": "Previous",
    "next": "Next",
    "go5back": "Go 5 back",
    "go5next": "Go 5 next",
    "items": "items",
    "itemsPerPage": "items per page"
}